import React from 'react';
import { DISCOUNT_CODE_LINK } from '../../config/links/links';
import {
  DISCOUNT_CODE_TEXT,
  EDITORIAL_PAGE_HEADING,
  EDITORIAL_TEAM,
  MEET_OUR_WRITERS_HEADING,
} from '../../config/text/text';
import EditorialTeamSection from './EditorialTeamSection';

const EditorialTeamContainer = () => {
  return (
    <>
      <h1>{MEET_OUR_WRITERS_HEADING}</h1>
      <div>{EDITORIAL_PAGE_HEADING}</div>
      <div className="discount-code-section">
        <span>{DISCOUNT_CODE_TEXT}</span>
        <span>
          <a href={DISCOUNT_CODE_LINK[process.env.NEXT_PUBLIC_SITE]}>
            {DISCOUNT_CODE_LINK[process.env.NEXT_PUBLIC_SITE]}
          </a>
        </span>
      </div>
      <div className="editor-section">
        {EDITORIAL_TEAM.map((editor) => (
          <EditorialTeamSection editorDetails={editor} key={editor.title} />
        ))}
      </div>
      <style jsx>{`
        .discount-code-section {
          margin-top: 4%;
        }
        .editor-section {
          margin-top: 4%;
        }
      `}</style>
    </>
  );
};

export default EditorialTeamContainer;
